import React, { Component } from 'react';

export default class Track extends Component {
    state = {
        playing:false,
        audio:null,
        playingPreviewUrl:null,
    };

    playAudio(trackUrl){
        //const audio
        const audio = new Audio(trackUrl);

        if(!this.state.playing){
            //play
            audio.play();
            this.setState({playing: true, audio, playingPreviewUrl: trackUrl});
        }
        else{
            //pause
            this.state.audio.pause();

            if(this.state.playingPreviewUrl === trackUrl){
                this.setState({playing: false});
            }
            else{
                //from pause to play
                audio.play();
                this.setState({audio, playingPreviewUrl: trackUrl});
            }
        }
    }

    trackIcon(trackUrl){
        if(!trackUrl){
            return <span className="text-danger"> N/T </span>
        }
        if(this.state.playing && this.state.playingPreviewUrl === trackUrl){
            //audio is in play state
            return <span className="glyphicon glyphicon-pause"></span>
        }
        return <span className="glyphicon glyphicon-play-circle"></span>
    }

    //convert ms to hh:mm:ss
    msToTime(s){
        var ms = s % 1000;
        s = (s - ms) / 1000;
        var sec = s % 60;
        s = (s - sec) / 60;
        var min = s % 60;
        var hrs = (s - min) / 60;
        return `${hrs}h:${min}m:${sec}s`;

    }
    render() {
        if(!this.props.tracks) return null;
        return (
            <div className="row">
                {this.props.tracks.map((item,key) => {
                    const {name, album, duration_ms, preview_url} = item;
                    return(
                        <div className="col-md-4 col-sm-6 col-xs-12" key={key}>
                            <div className="panel panel-primary" onClick={() => this.playAudio(preview_url)}>
                                <div className="panel-heading">
                    <h3 className="panel-title"> {name}</h3>
                                </div>
                                <div className="panel-body">
                            <img src={album.images[1].url} alt={name} className="img-responsive img-circle" />
                            <hr/>
                    <p className="text-info">Time {this.msToTime(duration_ms)}</p>
                                </div>
                                <div className="panel-footer">
                    <h3 className="text-info">{this.trackIcon(preview_url)}</h3>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        )
    }
}
